/**
 * This should be called at the end of every entry point, and is used to detect initialization that crashed in
 * any way (e.g. due to a syntax error from shipping JS that the browser can't understand). If the main
 * `<script>` tag completes and the variable is false, then it must have been stopped by a crash, so the
 * `check_js_loaded` server-side code shows an error to the user and reports the error to us.
 */
export default function markPageInitFinished(): void {
  window.BENCHLING_INITIALIZED = true;
}
